























import CommonModule       from "@/store/modules/common";
import { Component, Vue } from "vue-property-decorator";

@Component({
      name      : "LoadingIndicator",
      components: {
      }
  })
  export default class LoadingIndicator extends Vue {
      private opacity = 0.75;

      get fullscreenSynced(): boolean {
          this.opacity = CommonModule.fullscreen ? 1 : 0.75;
          return CommonModule.fullscreen;
      }

      set fullscreenSynced(value: boolean) {

          CommonModule.setFullscreen(value);
      }

      get showSynced(): boolean {
          return CommonModule.loading;
      }

      set showSynced(value: boolean) {
          CommonModule.setLoading(value);
      }
  }
